export function Skeleton({ width = '100%', height = 14, style = {} }) {
  return <div className="skeleton" style={{ width, height, ...style }} />;
}

export function TableSkeleton({ rows = 6, cols = 5 }) {
  const widths = ['55%', '80%', '65%', '70%', '50%'];
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <tbody>
        {Array.from({ length: rows }).map((_, i) => (
          <tr key={i} style={{ borderBottom: '1px solid var(--border)' }}>
            {Array.from({ length: cols }).map((_, j) => (
              <td key={j} style={{ padding: '13px 12px' }}>
                <Skeleton height={13} width={widths[j % widths.length]} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function CardSkeleton({ lines = 3 }) {
  const widths = ['40%', '75%', '60%', '85%'];
  return (
    <div className="card" style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 12 }}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} height={14} width={widths[i % widths.length]} />
      ))}
    </div>
  );
}
